import React from 'react'
import { FAQContainer, FAQTitle, FAQQuestion } from './FAQ.style'
import Collapse from 'components/Collapse'

const FAQ = props => {
  const data = props.data || []
  return (
    <FAQContainer>
      <FAQTitle id="product-faq">ხშირად დასმული შეკითხვები</FAQTitle>

      <FAQQuestion>
        {data.map(faq => (
          <Collapse key={faq.id} title={faq.question}>
            {faq.answer}
          </Collapse>
        ))}
      </FAQQuestion>
    </FAQContainer>
  )
}

export default FAQ
